import { FlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const Container = styled(FlexDiv)`
`

export const Description = styled.p``